import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

/**
 * Recursively checks if a block of a specific type exists in the block tree
 */
export const blockExists = (
  rootBlock: BaseBlock,
  blockType: string,
): boolean => {
  // Check if the current block matches the type
  if (rootBlock.type === blockType) {
    return true;
  }

  // Check children recursively
  if (rootBlock.props.children?.value) {
    const children = rootBlock.props.children.value as BaseBlock[];
    return children.some(child => blockExists(child, blockType));
  }

  return false;
};
